@if (breadcrumbs?.length) {
<div>
    <div class="flex flex-middle no-wrap">
        @for (crumb of getAllCrumbs('Home'); track $index; let last = $last) {
        <!-- IMPORTANT: we need nested span cause optHref creats a node and that causes problems for angular repeater -->
        <span>
            <href class="c1"
                  [ngClass]="getCrumbClass(last, crumb)"
                  [link]="crumb.url">{{crumb.label}}</href>
        </span>
        <!--
        NOTE:
        size here in ems is to keep chevron scale propertionaly to the label
        this requires both span and i having the same typography class
        -->
        @if (!last) {
        <i class="icon-chevron-right inline-flex icon-small col-5"
           style="margin-top: 2px;"></i>
        }
        }
    </div>
</div>
}